import { EmbeddedForm } from 'ui/components/3-organisms/EmbeddedForm';
import { useShouldShowContent } from 'helpers/audiencehelper';
import { useContext } from 'react';
import { ProfileContext } from 'application/adapters/context/Profile';

export const EmbeddedFormFeature: React.FC<Umbraco.EmbeddedForm> = ({ content }) => {
	const show = useShouldShowContent(content.properties.audiencePicker);
	const { isReady } = useContext(ProfileContext);

	if (!isReady) return null;

	return show ? (
		<EmbeddedForm
			formHtmlCode={content?.properties?.formHtmlCode}
			heading={content?.properties?.heading}
			image={content?.properties?.image}
			styleFlip={content?.properties?.styleFlip}
			imageGridSize={content?.properties?.imageGridSize}
			sectionWidth={content?.properties?.sectionWidth}
		/>
	) : null;
};
